import SubMenu from 'components/SubMenu';
import WP_Scripts from 'components/WP_Scripts';
import { addPageListener, addStorageListener, addUserListener, triggerHeaderLoaded } from 'eventFunctions';
import UserState from 'global_state/state/UserState';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Header from './components/Header';
import PageState from './global_state/state/PageState';
import reportWebVitals from './reportWebVitals';


const attachHeaderElements = (header_elements: HTMLCollectionOf<Element>) => {

  for (let i = 0; i < header_elements.length; i++) {
    // console.log(header_elements[i]);
    header_elements[i].closest('a')?.removeAttribute("href");
    let lang = header_elements[i].getAttribute('lang')
    const root = ReactDOM.createRoot(
      header_elements[i]
    );
    // console.log(root);
    
    
    
    root.render(
      <React.StrictMode>
        <PageState lang={lang}>
          <UserState>
            <Header />
          </UserState>
        </PageState>
      </React.StrictMode>
    );
  }
}
const attachSubMenuElements = (submenu_elements: HTMLCollectionOf<Element>) => {
  for (let i = 0; i < submenu_elements.length; i++) {
    submenu_elements[i].closest('a')?.removeAttribute("href");
    // console.log(submenu_elements[i]);
    let lang = submenu_elements[i].getAttribute('lang')

    const root = ReactDOM.createRoot(
      submenu_elements[i]
    );

    root.render(
      <React.StrictMode>
        <PageState lang={lang}>
          <UserState>
            <SubMenu />
          </UserState>
        </PageState>
      </React.StrictMode>
    );
  }
}

let interval = setInterval(() => {
  let header_elements = document.getElementsByClassName('xplore_react_reservations_header') 
  let submenu_elements = document.getElementsByClassName('xplore_react_reservations_submenu')

  // console.log(elements);
  // clearInterval(interval)

  // if (header_elements.length != 2 && submenu_elements.length != 2)  {
  //   return 
  // }

  
  // TODO: handle logged user - switch text in the header
  attachHeaderElements(header_elements)
  // TODO: add submenu ony if the user is logged in app
  attachSubMenuElements(submenu_elements)
  
  clearInterval(interval)
  triggerHeaderLoaded()

  // TODO: load WP_Scripts to manage the links in the wordpress 
  WP_Scripts(0);
  window.addEventListener('xf_user_logout', e => {
    // console.log(e);
    WP_Scripts(1)
  })
  window.addEventListener('xf_user_change', e => {
    // console.log(e);
    WP_Scripts(2)
  })


  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

  reportWebVitals();

}, 2000);







